export default "__VITE_ASSET__h$$oveuf__"